import { WohaCommonContent } from "../WohaCommonContent/WohaCommonContent";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";
export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="grid overflow-hidden rounded-2xl bg-charcoal md:min-h-[38rem] md:grid-cols-[0.9fr_1.1fr]">
    <WohaMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="h-full min-h-80 rounded-none md:order-2"
      imageClassName="h-full object-cover transition-transform duration-700 ease-out hover:scale-[1.02]"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <WohaCommonContent
      alignment={alignment}
      buttons={buttons}
      className="justify-center p-7 md:order-1 md:p-12 lg:p-16"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="text-5xl md:text-6xl lg:text-[4.5rem]"
      tone="dark"
    />
  </div>
);
HeroSplitImage.displayName = "Content::HeroSplitImage";
